/**
 * 一些基础的页面，不想分路由写了
 */
export default {
  routes: [
    {
      path: '/mind-tip',
      name: 'mind-tip',
      meta: {
        title: '转转保障'
      },
      component: () => import(/* webpackChunkName: "mindTip" */ '../views/mindTip/index.vue')
    },
    {
      path: '/c1-list-select',
      name: 'c1-list-select',
      meta: {
        pageId: 'X3970',
        level: 3,
        isAutoPV: false
      },
      component: () =>
        import(/* webpackChunkName: "ListForSelect" */ '../views/C1Convert/ListForSelect/Index.vue')
    },
    {
      path: '/c1-list-sale',
      name: 'c1-list-sale',
      meta: {
        title: '目标清单',
        pageId: 'G8848',
        level: 3,
        isAutoPV: false // 是否自动发送zpmshow埋点
      },
      component: () =>
        import(/* webpackChunkName: "ListForSale" */ '../views/C1Convert/ListForSale/Index.vue')
    },
    {
      path: '/c1-sale-type',
      name: 'c1-sale-type',
      meta: {
        title: '选择卖法',
        pageId: 'S1982',
        level: 3
      },
      component: () =>
        import(/* webpackChunkName: "SaleTypeList" */ '../views/C1Convert/SaleTypeList/Index.vue')
    },
    {
      path: '/c1-post-success',
      name: 'c1-post-success',
      meta: {
        title: '发布成功',
        pageId: 'E5803',
        level: 3
      },
      component: () =>
        import(/* webpackChunkName: "PostSuccess" */ '../views/C1Convert/PostSuccess/Index.vue')
    },
    {
      path: '/wish-goal',
      name: 'wish-goal',
      meta: {
        title: '心愿目标',
        pageId: 'T8921',
        level: 3
      },
      component: () =>
        import(/* webpackChunkName: "WishGoal" */ '../views/C1Convert/WishGoal/index.vue')
    },
    {
      path: '/url-warn', // url异常通用提示页面
      name: 'url-warn',
      component: () => import(/* webpackChunkName: "UrlWarn" */ '../views/commonPages/UrlWarn.vue')
    },
    {
      path: '/scan-code', // 扫码工具
      name: 'scan-code',
      meta: {
        title: '扫码工具',
        pageId: 'E7649',
        level: 3
      },
      component: () => import(/* webpackChunkName: "ScanCode" */ '../views/tools/ScanCode.vue')
    },
    {
      path: '/maintaining',
      name: 'maintaining',
      meta: {
        title: '维护公告'
      },
      component: () =>
        import(/* webpackChunkName: "Maintaining" */ '../views/applet/Maintaining.vue')
    }
  ]
}
